import React from "react";
import LoginPage from "./views/LoginPage";
import { LoginOtpContextProvider } from "./Loginview";
import LoginContent from "../../../../constants/contentFile.json";

const Login = () => {
  return (
    <LoginOtpContextProvider>
      <LoginPage textContents={LoginContent.loginPage} />
    </LoginOtpContextProvider>
  );
};

export default Login;
